/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DuplicateCandidateReviewDto
 */
export interface DuplicateCandidateReviewDto {
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateReviewDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateReviewDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateReviewDto
     */
    entityType?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateReviewDto
     */
    entityId1?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateReviewDto
     */
    entityId2?: string;
    /**
     * 
     * @type {number}
     * @memberof DuplicateCandidateReviewDto
     */
    confidenceScore?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DuplicateCandidateReviewDto
     */
    matchedRules?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof DuplicateCandidateReviewDto
     */
    matchDetails?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateReviewDto
     */
    status?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DuplicateCandidateReviewDto
     */
    autoMerge?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateReviewDto
     */
    matchOutcomeBand?: string;
    /**
     * 
     * @type {number}
     * @memberof DuplicateCandidateReviewDto
     */
    decisiveTier?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DuplicateCandidateReviewDto
     */
    tierShortCircuited?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DuplicateCandidateReviewDto
     */
    forceManualReview?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DuplicateCandidateReviewDto
     */
    guardVetoes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateReviewDto
     */
    definitiveMatchKey?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateReviewDto
     */
    sourceSystem1?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateReviewDto
     */
    sourceSystem2?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DuplicateCandidateReviewDto
     */
    entity1Data?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DuplicateCandidateReviewDto
     */
    entity2Data?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof DuplicateCandidateReviewDto
     */
    detectedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DuplicateCandidateReviewDto
     */
    reviewedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateReviewDto
     */
    reviewedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateReviewDto
     */
    reviewNotes?: string;
}

/**
 * Check if a given object implements the DuplicateCandidateReviewDto interface.
 */
export function instanceOfDuplicateCandidateReviewDto(value: object): value is DuplicateCandidateReviewDto {
    return true;
}

export function DuplicateCandidateReviewDtoFromJSON(json: any): DuplicateCandidateReviewDto {
    return DuplicateCandidateReviewDtoFromJSONTyped(json, false);
}

export function DuplicateCandidateReviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DuplicateCandidateReviewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'entityId1': json['entityId1'] == null ? undefined : json['entityId1'],
        'entityId2': json['entityId2'] == null ? undefined : json['entityId2'],
        'confidenceScore': json['confidenceScore'] == null ? undefined : json['confidenceScore'],
        'matchedRules': json['matchedRules'] == null ? undefined : json['matchedRules'],
        'matchDetails': json['matchDetails'] == null ? undefined : json['matchDetails'],
        'status': json['status'] == null ? undefined : json['status'],
        'autoMerge': json['autoMerge'] == null ? undefined : json['autoMerge'],
        'matchOutcomeBand': json['matchOutcomeBand'] == null ? undefined : json['matchOutcomeBand'],
        'decisiveTier': json['decisiveTier'] == null ? undefined : json['decisiveTier'],
        'tierShortCircuited': json['tierShortCircuited'] == null ? undefined : json['tierShortCircuited'],
        'forceManualReview': json['forceManualReview'] == null ? undefined : json['forceManualReview'],
        'guardVetoes': json['guardVetoes'] == null ? undefined : json['guardVetoes'],
        'definitiveMatchKey': json['definitiveMatchKey'] == null ? undefined : json['definitiveMatchKey'],
        'sourceSystem1': json['sourceSystem1'] == null ? undefined : json['sourceSystem1'],
        'sourceSystem2': json['sourceSystem2'] == null ? undefined : json['sourceSystem2'],
        'entity1Data': json['entity1Data'] == null ? undefined : json['entity1Data'],
        'entity2Data': json['entity2Data'] == null ? undefined : json['entity2Data'],
        'detectedAt': json['detectedAt'] == null ? undefined : (new Date(json['detectedAt'])),
        'reviewedAt': json['reviewedAt'] == null ? undefined : (new Date(json['reviewedAt'])),
        'reviewedBy': json['reviewedBy'] == null ? undefined : json['reviewedBy'],
        'reviewNotes': json['reviewNotes'] == null ? undefined : json['reviewNotes'],
    };
}

export function DuplicateCandidateReviewDtoToJSON(json: any): DuplicateCandidateReviewDto {
    return DuplicateCandidateReviewDtoToJSONTyped(json, false);
}

export function DuplicateCandidateReviewDtoToJSONTyped(value?: DuplicateCandidateReviewDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'entityType': value['entityType'],
        'entityId1': value['entityId1'],
        'entityId2': value['entityId2'],
        'confidenceScore': value['confidenceScore'],
        'matchedRules': value['matchedRules'],
        'matchDetails': value['matchDetails'],
        'status': value['status'],
        'autoMerge': value['autoMerge'],
        'matchOutcomeBand': value['matchOutcomeBand'],
        'decisiveTier': value['decisiveTier'],
        'tierShortCircuited': value['tierShortCircuited'],
        'forceManualReview': value['forceManualReview'],
        'guardVetoes': value['guardVetoes'],
        'definitiveMatchKey': value['definitiveMatchKey'],
        'sourceSystem1': value['sourceSystem1'],
        'sourceSystem2': value['sourceSystem2'],
        'entity1Data': value['entity1Data'],
        'entity2Data': value['entity2Data'],
        'detectedAt': value['detectedAt'] == null ? undefined : ((value['detectedAt']).toISOString()),
        'reviewedAt': value['reviewedAt'] == null ? undefined : ((value['reviewedAt']).toISOString()),
        'reviewedBy': value['reviewedBy'],
        'reviewNotes': value['reviewNotes'],
    };
}

